import React, { useEffect, useState } from "react";
import {
  FaGamepad,
  FaSave,
  FaClock,
} from "react-icons/fa";
import PageHeader from "../../components/PageHeader";
import notify from "../../utils/toast";
import {
  getGameSettings,
  updateGameSettings,
} from "../../api/endpoints";

const Settings = () => {
  const [loading, setLoading] = useState(false);

  const [gameSettings, setGameSettings] = useState({
    _id: "",
    game: "DRAGON_TIGER",
    isActive: true,
    bettingTime: 45,
    lockTime: 10,
    dragonOdd: 3,
    tigerOdd: 3,
    tieOdd: 15,
    minimumBet: 10,
    maximumBet: 10000,
  });

  useEffect(() => {
    fetchGameSettings();
  }, []);

  const fetchGameSettings = async () => {
    try {
      setLoading(true);

      const res = await getGameSettings();

      if (res.success && res.data.length > 0) {
        setGameSettings(res.data[0]);
      }
    } catch (err) {
      console.error(err);
      notify.error(err, "Could not load the Dragon Tiger settings");
    } finally {
      setLoading(false);
    }
  };

  const handleGameSettingChange = (e) => {
    const { name, value, type, checked } = e.target;

    setGameSettings((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : type === "number"
            ? Number(value)
            : value,
    }));
  };

  const handleSaveGameSettings = async () => {
    const minBet = Number(gameSettings.minimumBet);
    const maxBet = Number(gameSettings.maximumBet);

    if (minBet >= maxBet) {
      notify.warning("Minimum bet must be lower than maximum bet.", "Check the bet range");
      return;
    }

    try {
      setLoading(true);

      const res = await updateGameSettings(gameSettings);

      if (res.success) {
        notify.success(res.message || "Dragon Tiger settings are live.", "Settings saved");
        fetchGameSettings();
      } else {
        notify.error(res.message, "Could not save these settings");
      }
    } catch (err) {
      console.error(err);
      notify.error(err, "Could not save these settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page lead-page">
      <div className="row">
        <div className="col-lg-12">
          <PageHeader
            title="Dragon Tiger Settings"
            subtitle="Manage Dragon Tiger game settings"
          />

          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body">
              {/* <h5 className="fw-bold mb-4 d-flex align-items-center gap-2">
                <FaGamepad className="text-primary" />
                Dragon Tiger Settings
              </h5> */}

              <div className="row">

                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">
                    Game
                  </label>

                  <select
                    className="form-select"
                    name="game"
                    value={gameSettings.game}
                    onChange={handleGameSettingChange}
                  >
                    <option value="DRAGON_TIGER">Dragon Tiger</option>
                    {/* <option value="ANDAR_BAHAR">Andar Bahar</option> */}
                    {/* <option value="TEEN_PATTI">Teen Patti</option> */}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">
                    Dragon Odd
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="dragonOdd"
                    value={gameSettings.dragonOdd}
                    onChange={handleGameSettingChange}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">
                    Tiger Odd
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="tigerOdd"
                    value={gameSettings.tigerOdd}
                    onChange={handleGameSettingChange}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">
                    Tie Odd
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="tieOdd"
                    value={gameSettings.tieOdd}
                    onChange={handleGameSettingChange}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">
                    <FaClock className="me-1" />
                    Betting Time
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="bettingTime"
                    value={gameSettings.bettingTime}
                    onChange={handleGameSettingChange}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">
                    <FaClock className="me-1" />
                    Lock Time
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    name="lockTime"
                    value={gameSettings.lockTime}
                    onChange={handleGameSettingChange}
                  />
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">
                    Minimum Bet
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">₹</span>
                    <input
                      type="number"
                      className="form-control"
                      name="minimumBet"
                      value={gameSettings.minimumBet}
                      onChange={handleGameSettingChange}
                    />
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <label className="form-label fw-semibold">
                    Maximum Bet
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">₹</span>
                    <input
                      type="number"
                      className="form-control"
                      name="maximumBet"
                      value={gameSettings.maximumBet}
                      onChange={handleGameSettingChange}
                    />
                  </div>
                </div>

                <div className="col-md-12 mb-3">
                  <label className="form-label fw-semibold">
                    Status
                  </label>

                  <div className="form-check form-switch mt-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="isActive"
                      checked={gameSettings.isActive}
                      onChange={handleGameSettingChange}
                      style={{
                        width: "3em",
                        height: "1.5em",
                      }}
                    />

                    <label className="form-check-label ms-2">
                      <span
                        className={`badge ${gameSettings.isActive
                          ? "bg-success"
                          : "bg-danger"
                          }`}
                      >
                        {gameSettings.isActive ? "Active" : "Inactive"}
                      </span>
                    </label>
                  </div>
                </div>
              </div>

              <div className="text-end mt-3">
                <button
                  className="btn btn-primary px-4"
                  onClick={handleSaveGameSettings}
                  disabled={loading}
                >
                  <FaSave className="me-2" />
                  {loading ? "Saving..." : "Save Settings"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;